import {
  SET_ONLINE,
  SET_RANKING,
  SET_EVENT_IMAGE,
  SET_LOADING,
  SET_DOWNLOAD_LINK,
  SET_SERVER_INFO,
  SET_EVENTS,
  SET_DONATION_DETAILS,
  SET_SHOW_ONLINE
} from './types.js'

export default {
    [SET_EVENT_IMAGE] (state , payload) {
      state.event_image = payload
    },
    [SET_RANKING] (state , payload) {
      state.ranking = payload
    },
    [SET_ONLINE] (state , payload) {
      state.online = payload
    },
    [SET_DOWNLOAD_LINK] (state , payload) {
      state.downloadLinks = payload
    },
    [SET_LOADING] (state, payload) {
      state.loading = payload
    },
    [SET_SERVER_INFO] (state, payload) {
      state.serverInfo = payload
    },
    [SET_EVENTS] (state, payload) {
      state.events = payload
    },
    [SET_DONATION_DETAILS] (state, payload) {
      state.donation_info = payload
    },
    [SET_SHOW_ONLINE] (state, payload) {
      state.show_online = payload
    }
}